import { ReactNode } from "react";
import Icon from "components/Icon";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "./NormalModal.styled";

type NormalModalProps = {
  title: any;
  children: ReactNode;
  footer?: ReactNode;
  onClose: () => void;
  open: boolean;
  paperSx?: any;
  dialogSx?: any;
  className?: string;
};

export function NormalModal({
  title,
  children,
  footer,
  onClose,
  open,
  paperSx,
  className,
}: NormalModalProps) {
  return (
    <Dialog
      className={className}
      open={open}
      onClose={onClose}
      scroll="paper"
      PaperProps={{
        sx: { minWidth: "300px", maxWidth: "initial", ...paperSx },
      }}
      disableEnforceFocus
    >
      <DialogTitle>
        {title}
        <IconButton aria-label="close" color="inherit" onClick={onClose}>
          <Icon variant="close" />
        </IconButton>
      </DialogTitle>
      <DialogContent>{open && children}</DialogContent>
      {footer && <DialogActions>{footer}</DialogActions>}
    </Dialog>
  );
}
